
export const fileConfigList = [
    {
        "id": "1",
        "material_type": "1",
        "type": "1",
        "material_is_null": "0",
        "conf_resolution": "720*1280",
        "conf_size": "102400",
        "conf_size_name": "100.00KB",
        "min_conf_length": null,
        "conf_length": null,
        "conf_format": "jpg/jpeg/png",
        "explicit_name": "竖版封面"
    },
    {
        "id": "2",
        "material_type": "1",
        "type": "2",
        "material_is_null": "0",
        "conf_resolution": "720*1280",
        "conf_size": "102400",
        "conf_size_name": "100.00KB",
        "min_conf_length": null,
        "conf_length": null,
        "conf_format": "jpg/jpeg/png",
        "explicit_name": "竖版图片"
    },
    {
        "id": "3",
        "material_type": "3",
        "type": "3",
        "material_is_null": "0",
        "conf_resolution": "720*1280",
        "conf_size": "52428800",
        "conf_size_name": "50.00MB",
        "min_conf_length": "4000",
        "conf_length": "300000",
        "conf_format": "mp4",
        "explicit_name": "竖版视频"
    },
    {
        "id": "4",
        "material_type": "1",
        "type": "1",
        "material_is_null": "0",
        "conf_resolution": "1280*720",
        "conf_size": "102400",
        "conf_size_name": "100.00KB",
        "min_conf_length": null,
        "conf_length": null,
        "conf_format": "jpg/jpeg/png",
        "explicit_name": "横版封面"
    },
    {
        "id": "5",
        "material_type": "1",
        "type": "2",
        "material_is_null": "0",
        "conf_resolution": "1280*720",
        "conf_size": "102400",
        "conf_size_name": "100.00KB",
        "min_conf_length": null,
        "conf_length": null,
        "conf_format": "jpg/jpeg/png",
        "explicit_name": "横版图片"
    },
    {
        "id": "6",
        "material_type": "3",
        "type": "3",
        "material_is_null": "0",
        "conf_resolution": "1280*720",
        "conf_size": "52428800",
        "conf_size_name": "50.00MB",
        "min_conf_length": "4000",
        "conf_length": "300000",
        "conf_format": "mp4",
        "explicit_name": "横版视频"
    }
]